import { Type } from "@sinclair/typebox";
export const Condition = Type.Object({
    type: Type.String(),
    usergroupIds: Type.Optional(Type.Array(Type.String())),
    notUsergroupIds: Type.Optional(Type.Array(Type.String())),
});
export const ConditionGroup = Type.Object({
    isIgnored: Type.Optional(Type.Boolean()),
    conditions: Type.Optional(Type.Array(Condition)),
    mode: Type.Optional(Type.Union([Type.Literal("AND"), Type.Literal("OR")])),
}, {
    title: "ConditionGroup",
});
export const FileAsset = Type.Object({
    fileUuid: Type.String(),
    uploadSessionId: Type.Optional(Type.String()),
}, {
    title: "FileAsset",
});
export const TranslatedString = Type.Array(Type.Object({
    locale: Type.String(),
    value: Type.String(),
}), { title: "TranslatedString", minItems: 1 });
